module.exports = global["XRegExp"] = require("-!/data/jenkins_data/workspace/rintos_skyline-start_master-DYGZOXRMPXXNLR4QKF2JKJKT4EHE6U4HPBUF3ZUW2UTNWWCARJZQ/node_modules/xregexp/src/index.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?XRegExp!../~/xregexp/src/index.js
// module id = 147
// module chunks = 1